import { CloseOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import AlarmInfo from './AlarmInfo';
import alarmMarkerImg from './Icons/alarmMarker.png';

const AlarmMarker = ({ triggeredAt, lat, lng, name }) => {
  const [infoVisible, setInfoVisible] = useState(false);
  const [hover, setHover] = useState(false);

  const toggleHover = () => setHover(!hover);
  const handleClick = () => setInfoVisible(!infoVisible);

  const markerStyle = hover
    ? {
        position: 'absolute',
        width: '26px',
        height: '26px',
        left: '-13px',
        top: '-13px',
        zIndex: 4,
      }
    : {
        position: 'absolute',
        width: '12px',
        height: '12px',
        left: '-6px',
        top: '-6px',
        zIndex: 4,
      };

  return (
    <>
      <Popover
        style={{
          height: '50px',
          width: '130px',
          zIndex: 5,
          top: '-50px',
          left: '-65px',
          position: 'relative',
        }}
        open={infoVisible}
        trigger="click"
        title={
          <AlarmInfo
            alarm={name}
            render={
              <span>
                {`Alarm: ${name}`}
                <CloseOutlined
                  onClick={handleClick}
                  style={{ float: 'right' }}
                />
              </span>
            }
          />
        }
        content={`triggered at: ${triggeredAt}`}
      />

      <img
        key={triggeredAt}
        style={markerStyle}
        data-lat={lat}
        data-lng={lng}
        height="12px"
        width="12px"
        alt="marker"
        onClick={handleClick}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
        src={alarmMarkerImg}
      />
    </>
  );
};

AlarmMarker.propTypes = {
  triggeredAt: PropTypes.string,
  lat: PropTypes.number,
  lng: PropTypes.number,
  name: PropTypes.string,
};

export default AlarmMarker;
